import axios from '../utils/axios';
import { CalibrationParameters } from '../types/CalibrationParameters';

export async function updateConfig(configId: string, data: any): Promise<any> {
  return axios.put(`/configs/${configId}`, data).then((res) => res.data);
}

export async function createConfig(data: any): Promise<any> {
  return axios.post('/configs', data).then((res) => res.data);
}

export async function deleteConfig(configId: string): Promise<any> {
  return axios.delete(`/configs/${configId}`).then((res) => res.data);
}

export async function getConfig(configId: string, scope?: string): Promise<CalibrationParameters> {
  const queryString = scope ? `?scope=${scope.toString()}` : '';
  return axios.get(`/configs/${configId}${queryString}`).then((res) => res.data);
}

export async function getConfigs(calibrationIds?: string[]): Promise<any[]> {
  const queryString = calibrationIds && calibrationIds.length > 0 ? `?id=${calibrationIds.join(',')}` : '';
  return axios.get(`/configs${queryString}`).then((res) => res.data);
}

export async function batchUpdateConfigs(configs: any[]): Promise<any> {
  return axios.put('/configs', configs).then((res) => res.data);
}
